import { Injectable } from "@angular/core";
import AWSAppSyncClient from "aws-appsync";
import appSyncConfig from "../../../../AppSync.js";
import { AUTH_TYPE } from "aws-appsync";
import Auth from "@aws-amplify/auth";

@Injectable()
export class AppSyncService {
  client;
  hc;

  constructor() {
    this.client = new AWSAppSyncClient(
      {
        url: appSyncConfig.graphqlEndpoint,
        region: appSyncConfig.region,
        disableOffline: true,
        auth: {
          type: AUTH_TYPE.AWS_IAM,
          credentials: () => Auth.currentCredentials()
        }
      },
      {
        defaultOptions: {
          query: {
            fetchPolicy: "network-only",
            errorPolicy: "all"
          }
        }
      }
    );
    this.hc = this.client.hydrated;
  }
}
